import { FC } from "react";

import { FiltersContainer } from "@pages/Catalog/components/components";
import Filters from "@pages/Catalog/components/Filters/Filters";

import { useFiltersData } from "@hooks/useFiltersData";

import Loadable from "@layouts/Loadable";

interface IFilterSection {
  handleSetFilters: (item: string[]) => void;
}

const FiltersSection: FC<IFilterSection> = ({ handleSetFilters }) => {
  const { initialValues, uniqueTags, availableTags, dataFilters, maxBpm, maxLength, handleSubmit, isLoading } =
    useFiltersData(handleSetFilters);

  return (
    <FiltersContainer width="100%">
      <Loadable isLoading={isLoading}>
        <Filters
          maxLength={maxLength}
          maxBpm={maxBpm}
          handleSubmitForm={handleSubmit}
          initialFiltersValues={initialValues}
          uniqueTags={uniqueTags}
          availableTags={availableTags}
          dataFilters={dataFilters}
        />
      </Loadable>
    </FiltersContainer>
  );
};

export default FiltersSection;
